// components/MatchingSection.js
import React from "react";

function MatchingSection() {
  return (
    <section
      className="py-16"
      style={{ backgroundColor: "rgba(244, 249, 252, 1)" }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-start justify-between gap-12">
          {/* Left Column: Text Steps */}
          <div className="md:w-1/2 w-full">
            <h2 className="text-4xl font-bold text-gray-800 leading-tight mb-4">
              Perfectly matched talent with your online business goals
            </h2>
            <p className="text-gray-600 mb-10">
              Exponent’s unique algorithm matches you with vetted experts that are a perfect fit for what you actually need Marketing experts.
            </p>

            {/* Step List */}
            <div className="space-y-10">
              {/* Step 1 */}
              <div>
                <p className="text-customcolor font-semibold mb-1">Step 1</p>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">
                  Outline your business goals
                </h4>
                <p className="text-gray-600">
                  Create a clear business brief that identifies your unique business needs and goals.
                </p>
                <hr className="mt-4 border-t border-gray-300 w-full" />
              </div>

              {/* Step 2 */}
              <div>
                <p className="text-customcolor font-semibold mb-1">Step 2</p>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">
                  Reach your right marketing
                </h4>
                <p className="text-gray-600">
                  Exponent’s unique algorithm matches you with vetted experts that are a perfect fit for what you actually need Marketing experts in your niche.
                </p>
                <hr className="mt-4 border-t border-gray-300 w-full" />
              </div>

              {/* Step 3 */}
              <div>
                <p className="text-customcolor font-semibold mb-1">Step 3</p>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">
                  Get consistent monitoring
                </h4>
                <p className="text-gray-600">
                  Create a clear business brief that identifies your unique business needs and goals.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Graphic Image */}
          <div className="md:w-1/2 w-full flex justify-center md:justify-end">
          <img
            src="assets/images/home/exponent-marketing-goal-1.png"
            alt="Dashboard"
            className="rounded-xl shadow-xl w-full md:max-w-xl"
          />
        </div>
        </div>
      </div>
    </section>
  );
}


export default MatchingSection;
